"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const SearchContext_1 = __importDefault(require("../../contexts/SearchContext"));
const Popover_1 = __importDefault(require("../Popover/Popover"));
const SearchResultsPopover = (props) => {
    const { children } = props;
    const { loadOnFocus, searchHits, setSearchHits, searchInputRef, inputFocused, searchHitPaginator } = react_1.useContext(SearchContext_1.default);
    // we expect children to be a function we can pass searchHits to
    return (react_1.default.createElement(Popover_1.default, Object.assign({ targetRef: searchInputRef, isOpen: inputFocused && (loadOnFocus || searchHits.length > 0 || !!searchHitPaginator.error) }, props, { onClose: () => setSearchHits([]) }), children));
};
exports.default = __1.withJourney('j-search-results-popover', SearchResultsPopover);
